import { createFileRoute } from "@tanstack/react-router"

import { RecordDetail } from "@/features/records/record-detail"

export const Route = createFileRoute("/records/$recordId")({ component: RecordScreen })

function RecordScreen() {
  // The id is the server's, arriving as a path string. The screen deals with a
  // number and says so plainly when the address does not carry one.
  const { recordId } = Route.useParams()
  return <RecordDetail recordId={Number(recordId)} />
}
